import { formatToCurrencyType } from "helper/common";
import React from "react";
import {FIELD_TYPE, FORMAT_TIME} from "types/enums";
import {DataFormField} from "types/models/input-field-type";
import dayjs from 'dayjs';
const {INPUT, SELECT, DATE, COMBO_BOX, NUMBER} = FIELD_TYPE;

const cssProps3 = {
  labelCol: {xs: 4, sm: 4, md: 4, lg: 4, xl: 4},
  wrapperCol: {xs: 20, sm: 20, md: 20, lg: 20, xl: 20},
  css: {xs: 24, sm: 24, md: 24, lg: 24, xl: 24},
}
const searchFields: DataFormField[] = [
  // {
  //   type: INPUT,
  //   label: "Mã dịch vụ",
  //   name: "id",
  //   expand: false,
  // },
  {
    type: INPUT,
    label: "Tên dịch vụ",
    name: "tenDichVu",
    expand: false,
    ...cssProps3
  }
]

const serviceTable: any = [
  {
    title: "STT",
    dataIndex: "stt",
    show: true,
    isResizable: true,
    render: (value, record, index) => (index + 1),
    align: "center",
  },
  { title: "Mã", dataIndex: "id", show: true, align: "left", isResizable: true, },
  {
    title: "Tên dịch vụ", dataIndex: "tenDichVu", show: true, align: "left", isResizable: true,
  }, 
  {
    title: "Giá BV", dataIndex: "donGia", show: true, align: "right",
    isResizable: true,
    render: (v, r, i) => formatToCurrencyType(v)
  },
  {
    title: "Giá BHYT", dataIndex: "bhChiTra", show: true, align: "right",
    isResizable: true,
    render: (v, r, i) => formatToCurrencyType(v)
  },
  {
    title: "Mô tả", dataIndex: "moTa", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Ngày cập nhật", dataIndex: "modifiedDate", show: true, align: "center",width:120,
    isResizable: true,
    render: (value, record, index) => {
      if (value) {
        return dayjs(value)?.format("DD/MM/YYYY HH:mm");
      } else {
        return value;
      }
    },
  },
  {
    title: "Trạng thái", dataIndex: "trangThai", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Nhóm", dataIndex: "idNhomDichVu", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Phân loại", dataIndex: "phanLoai", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Khoa", dataIndex: "khoa", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "STT_BYT", dataIndex: "sttBYT", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "STT_Chuong", dataIndex: "sttChuong", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Chương", dataIndex: "chuong", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Mã TT 43.21", dataIndex: "maTT4321", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Phân loại PTTT", dataIndex: "phanLoaiPTTT", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Số lượng", dataIndex: "soLuong", show: true, align: "right",
    isResizable: true,
  },
  {
    title: "Cần tư vấn", dataIndex: "canTuVan", show: true, align: "center",
    isResizable: true,
  },
  {
    title: "Mã BHYT", dataIndex: "idBHYT", show: true, align: "left",
    isResizable: true,
  },
  {
    title: "Có bảo hiểm", dataIndex: "coBaoHiem", show: true, align: "center",
    isResizable: true,
  },
  {
    title: "Thao tác", dataIndex: "action", show: true, align: "left",
    isResizable: true,
  },
]

export {
  searchFields,
  serviceTable
}